// src/pages/AdminPersonalize.jsx
import React from 'react';
import AdminPersonalizePage from '../../components/admin/AdminPersonalizePage';
export default function AdminPersonalize() {
  return <AdminPersonalizePage />;
}
